<template>
  <div class="flex flex-1 flex-col">
    <MRow :gutter="0">
      <MCol :size="12">
        <MRow :gutter="0" class="flex-1">
          <MCol v-for="item in items" :key="item.id" :size="12">
            <MCollapse
              :accordion="false"
              :default-active-key="items[0].table.title"
            >
              <MCollapsePanel
                :key="item.table.title"
                :header="item.table.title"
              >
                <!-- <template v-slot:header>
                  <h3 class="mb-0 text-primary">
                    {{ $tc('table') }}: {{ item.table.title }}
                  </h3>
                </template> -->

                <MRow :gutter="0">
                  <MCol>
                    <!-- <h4>{{ $tc('table') }}: {{ item.table.title }}</h4> -->
                    <MDivider style="margin: 1px" />
                    <ResizableTable
                      :use-scroll="false"
                      sticky-headers
                      :min-height="0"
                    >
                      <table key="tabular-list" class="item-list-table w-full">
                        <thead>
                          <tr>
                            <td
                              v-for="column in getTableColumns(item.table)"
                              :key="column"
                            >
                              {{ column }}
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(row, index) in item.table.rowList"
                            :key="index"
                          >
                            <td
                              v-for="column in getTableColumns(item.table)"
                              :key="column"
                              class="text-ellipsis"
                              :title="row.cellValues[column]"
                            >
                              {{ row.cellValues[column] }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </ResizableTable>
                  </MCol>
                </MRow>
              </MCollapsePanel>
            </MCollapse>
          </MCol>
        </MRow>
      </MCol>
    </MRow>
  </div>
</template>

<script>
import ResizableTable from '@components/table/resizable-table'
import { getSnmpPropertyValueApi } from '../../asset-api'
export default {
  name: 'TabularPropertyValueTab',
  components: { ResizableTable },
  props: {
    resourceId: { type: Number, required: true },
  },
  data() {
    return {
      items: [],
    }
  },
  created() {
    this.getValueDetails()
  },
  methods: {
    getValueDetails() {
      getSnmpPropertyValueApi(this.resourceId, 'tabular').then((data) => {
        this.items = data.items
      })
    },
    getTableColumns(table) {
      const singleCell = (table.rowList[0] || {}).cellValues
      return Object.keys(singleCell).map((key) => key)
    },
  },
}
</script>
